<template lang="pug">
  ul.tree
    li.tree-item(v-for="child in node" :key="child.fqdn" )
      NodeLink.tree-item__link(:node="child"  @click.native="checkOpenedFolder(child.fqdn)")

      TransitionExpand
        Node(v-if="isShowChildren(child) || openedFromReferences(child.fqdn)"
          :class="child.kind"
          :node="child.children"
        )

</template>

<script>
import NodeLink from './NodeLink.vue';
import TransitionExpand from '../../ui/TransitionExpand.vue';
import GlobalBus from '@/plugins/GlobalBus';

// PAY ATTENTION! Изменение этого компонента в ооп-стиль сломает дерево. Оставлять в функциональном!
export default {
  name: 'Node',
  components: {
    NodeLink,
    TransitionExpand,
  },
  props: {
    node: Array,
  },
  data() {
    return {
      currentFqdn: '',
      isOpenedFolder: false,
      outsideLink: '',
      sameLinks: 0,
    };
  },
  created() {
    this.currentFqdn = this.$route.meta.fqdn;
  },
  beforeMount() {
    GlobalBus.off('openLink');
  },
  mounted() {
    GlobalBus.on('openLink', this.takeLinkFromReferences);
  },
  methods: {
    /**
     * Тугл папки
     */
    checkOpenedFolder(fqdn) {
      if (this.isOpenedFolder) {
        this.isOpenedFolder = false;
        this.currentFqdn = fqdn;
        return;
      }

      this.isOpenedFolder = fqdn === this.currentFqdn;
      this.currentFqdn = fqdn;
    },
    openedFromReferences(fqdn) {
      if (this.outsideLink === fqdn) {
        this.checkOpenedFolder(fqdn);
        // Обнуляем outsideLink для того чтобы при следующих проходах оно не пыталось обратно открыть ее
        this.outsideLink = '';
        return true;
      } else return false;
    },
    takeLinkFromReferences(fqdn) {
      if (!fqdn || !fqdn.length) return;

      this.outsideLink = fqdn.join('.');
    },
    /**
     * Проверяем, показываем ли мы детей этого предка или нет. Проверяем на папку, есть ли дети и соответствует ли fqdn текущему (на который уже перешли)
     */
    isShowChildren(child) {
      if (!this.currentFqdn) return false;

      const checkChildren = child.children && !this.isOpenedFolder;

      if (!checkChildren) return false;

      const regex = new RegExp(`${child.fqdn}(\\.|$)`);
      return regex.test(this.currentFqdn);
    },
  },
};
</script>
